import { useEffect, useState } from "react";

import DashboardHeader from "./component/DashboardHeader";
import DashboardStats from "./component/DashboardStats";
import ProjectStatusChart from "./component/ProjectStatusChart";
import ProjectWorkloadChart from "./component/ProjectWorkloadChart";
import ProjectCostChart from "./component/ProjectCostChart";

import ProjectTable from "../table/ProjectTable";
import ProjectDrawer from "../drawer/ProjectDrawer";
import EditProjectDrawer from "../drawer/EditProjectDrawer";

import { getProjects } from "../services/project.service";
import { getProjectMembers } from "../services/employeeService";

const Dashboard = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedProject, setSelectedProject] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [editingProject, setEditingProject] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getProjects();

      const projectList = response?.data || [];

      console.log("PROJECT LIST:", projectList);

      // Fetch members for every project
      const projectsWithMembers = await Promise.all(
        projectList.map(async (project) => {
          const projectUuid =
            project.uuid ||
            project.project_uuid;

          if (!projectUuid) {
            return {
              ...project,
              members: [],
            };
          }

          try {
            const memberResponse =
              await getProjectMembers(projectUuid);

            const members =
              memberResponse?.data || [];

            return {
              ...project,
              members,
            };
          } catch (error) {
            console.error(
              "MEMBER FETCH ERROR:",
              projectUuid,
              error
            );

            return {
              ...project,
              members: [],
            };
          }
        })
      );

      console.log(
        "PROJECTS WITH MEMBERS:",
        projectsWithMembers
      );

      setProjects(projectsWithMembers);
    } catch (error) {
      console.error(
        "Failed to fetch projects:",
        error
      );

      setError("Failed to load projects.");
    } finally {
      setLoading(false);
    }
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setOpenDrawer(true);
  };

  const handleEditProject = (project) => {
    setEditingProject(project);
  };

  const handleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };

  if (loading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <p className="text-sm text-slate-500">
          Loading projects...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="rounded-lg border border-red-200 bg-red-50 p-4">
          <p className="text-sm font-medium text-red-600">
            {error}
          </p>

          <button
            onClick={fetchProjects}
            className="mt-3 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`w-full px-4 lg:px-6 ${
        isFullscreen ? "px-0 lg:px-0" : ""
      }`}
    >
      {!isFullscreen && (
        <div className="pt-4">
          <div className="mb-6">
            <DashboardHeader />
          </div>

          <div className="mb-5">
            <DashboardStats projects={projects} />
          </div>

          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            <ProjectStatusChart
              projects={projects}
            />

            <ProjectWorkloadChart
              projects={projects}
            />

            <ProjectCostChart
              projects={projects}
            />
          </div>
        </div>
      )}

      <div className={!isFullscreen ? "mt-5" : ""}>
        <ProjectTable
          projects={projects}
          onProjectClick={handleProjectClick}
          onFullscreen={handleFullscreen}
          onEditProject={handleEditProject}
          isFullscreen={isFullscreen}
        />
      </div>

      <ProjectDrawer
        open={openDrawer}
        project={selectedProject}
        onClose={() => {
          setOpenDrawer(false);
          setSelectedProject(null);
        }}
      />

      <EditProjectDrawer
        open={!!editingProject}
        project={editingProject}
        onClose={() => setEditingProject(null)}
      />
    </div>
  );
};

export default Dashboard;